import React from 'react';
import { MdSwapHoriz, MdLocationOn } from 'react-icons/md';
import ReactPaginate from 'react-paginate';
import TableLoadingWrapper from './TableLoadingWrapper';
import '../../styles/views.css';

const TransactionsView = ({
  pagedFilteredData,
  searchTerm,
  setSearchTerm,
  pageCount,
  handlePageClick,
  loading,
  userRole,
  userMmdaId,
}) => {
  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'successful':
      case 'success':
        return { bg: '#e8f5e8', color: '#2e7d32' };
      case 'failed':
      case 'error':
        return { bg: '#ffebee', color: '#c62828' };
      case 'pending':
        return { bg: '#fff3cd', color: '#856404' };
      default:
        return { bg: '#f5f5f5', color: '#666' };
    }
  };

  return (
    <>
      {/* Header */}
      <div style={{ marginBottom: 16, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <input
          type="text"
          placeholder="Search regional transactions..."
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          style={{
            width: 300,
            padding: '8px 12px',
            borderRadius: 4,
            border: '1px solid #ccc',
            fontSize: 16,
            outline: 'none',
          }}
        />
        
        <div style={{
          padding: '10px 16px',
          backgroundColor: '#e3f2fd',
          color: '#1976d2',
          border: '1px solid #bbdefb',
          borderRadius: 6,
          fontSize: 14,
          fontWeight: 'bold',
        }}>
          Regional Transactions Only
        </div>
      </div>

      {/* Transactions Table */}
      <TableLoadingWrapper loading={loading}>
        <div style={{ overflowX: 'auto' }}>
          <table>
            <thead>
              <tr>
                <th>Transaction ID</th>
                <th>Amount</th>
                <th>Status</th>
                <th>Payment Method</th>
                <th>Zone</th>
                <th>Revenue Officer</th>
                <th>Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {pagedFilteredData.map((row, i) => {
                const statusStyle = getStatusColor(row.status);
                return (
                  <tr key={i} style={{ cursor: 'default' }}>
                    <td>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <MdSwapHoriz size={16} style={{ color: '#1976d2' }} />
                        <span style={{ fontFamily: 'monospace', fontSize: 12 }}>
                          {row.transaction_id || `TXN-${row.id}`}
                        </span>
                      </div>
                    </td>
                    <td>
                      <strong style={{ color: '#2e7d32', fontSize: 14 }}>
                        GH₵ {parseFloat(row.amount || 0).toFixed(2)}
                      </strong>
                    </td>
                    <td>
                      <span style={{
                        padding: '4px 8px',
                        borderRadius: 4,
                        fontSize: 12,
                        fontWeight: 'bold',
                        backgroundColor: statusStyle.bg,
                        color: statusStyle.color
                      }}>
                        {(row.status || 'pending').charAt(0).toUpperCase() + (row.status || 'pending').slice(1)}
                      </span>
                    </td>
                    <td>
                      <span style={{
                        padding: '4px 8px',
                        backgroundColor: '#f3e5f5',
                        borderRadius: 4,
                        fontSize: 12,
                        color: '#7b1fa2'
                      }}>
                        {row.payment_method || 'Cash'}
                      </span>
                    </td>
                    <td>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                        <MdLocationOn size={14} style={{ color: '#1976d2' }} />
                        <span style={{
                          padding: '4px 8px',
                          backgroundColor: '#e3f2fd',
                          borderRadius: 4,
                          fontSize: 12,
                          color: '#1976d2'
                        }}>
                          {row.zone_name || 'N/A'}
                        </span>
                      </div>
                    </td>
                    <td>{row.officer_name || 'N/A'}</td>
                    <td>{new Date(row.created_at).toLocaleDateString()}</td>
                    <td>
                      <div style={{ display: 'flex', gap: 8 }}>
                        <button
                          onClick={() => console.log('View transaction details:', row)}
                          style={{
                            padding: '6px 12px',
                            backgroundColor: '#1976d2',
                            color: 'white',
                            border: 'none',
                            borderRadius: 4,
                            cursor: 'pointer',
                            fontSize: 12,
                          }}
                        >
                          Details
                        </button>
                        <button
                          onClick={() => console.log('View receipt:', row)}
                          style={{
                            padding: '6px 12px',
                            backgroundColor: '#28a745',
                            color: 'white',
                            border: 'none',
                            borderRadius: 4,
                            cursor: 'pointer',
                            fontSize: 12,
                          }}
                        >
                          Receipt
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </TableLoadingWrapper>

      {/* Pagination */}
      {pageCount > 1 && (
        <ReactPaginate
          previousLabel={'previous'}
          nextLabel={'next'}
          breakLabel={'...'}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={handlePageClick}
          containerClassName={'pagination'}
          activeClassName={'active'}
        />
      )}

      {/* Transaction Management Info */}
      <div style={{
        marginTop: 20,
        padding: 15,
        backgroundColor: '#e3f2fd',
        borderRadius: 8,
        border: '1px solid #bbdefb',
        fontSize: 14,
        color: '#1976d2'
      }}>
        <strong>Regional Transaction Management:</strong> View and track all transactions within your MMDA region. 
        Monitor revenue collection performance and transaction statuses across your zones.
      </div>
    </>
  );
};

export default TransactionsView;
